import { ErrorBoundary } from 'react-error-boundary';
import { Navigate, Route, Routes } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import FeatureMaintenance from '@autopass-web/feature-maintenance';
import { EventServiceProvider } from '@autopass-web/mochi-analytics/event';

import {
  AuthCreditCard,
  AuthJKOPay,
  AuthTaiwanPay,
  Entry,
  ErrorRoutes,
  Expired,
  GeneralError,
  Invoices,
  NotFound,
  Payment,
  StoreCancelled,
  Success,
  UserCancelled,
} from './pages';
import { analyticsService } from './services/analytics';
import { AppContextProvider } from './stores/app-context';

import './utils/version-log';

const queryClient = new QueryClient();

const fallbackRender = ({ error }) => {
  return (
    <div role="alert">
      <p>Oops 好像有什麼東西出錯了...</p>
      <div style={{ color: 'red' }}>{error.message}</div>
    </div>
  );
};

export function App() {
  return (
    <ErrorBoundary FallbackComponent={fallbackRender}>
      <FeatureMaintenance>
        <QueryClientProvider client={queryClient}>
          <EventServiceProvider logger={analyticsService.logEvent}>
            <AppContextProvider>
              <Routes>
                <Route path="/notfound" element={<NotFound />} />
                <Route path="/invoices/:invoiceId" element={<Invoices />}>
                  <Route index element={<Payment />} />
                  <Route path="auth">
                    <Route path="credit-card" element={<AuthCreditCard />} />
                    <Route path="jkopay" element={<AuthJKOPay />} />
                    <Route path="taiwan-pay" element={<AuthTaiwanPay />} />
                    <Route
                      path="*"
                      element={<Navigate replace relative="path" to="../.." />}
                    />
                  </Route>
                  <Route path="entry" element={<Entry />} />
                  <Route path="error" element={<ErrorRoutes />}>
                    <Route index element={<GeneralError />} />
                    <Route path="expired" element={<Expired />} />
                    <Route path="user-cancelled" element={<UserCancelled />} />
                    <Route
                      path="store-cancelled"
                      element={<StoreCancelled />}
                    />
                    <Route
                      path="*"
                      element={<Navigate replace relative="path" to=".." />}
                    />
                  </Route>
                  <Route path="success" element={<Success />} />
                  <Route
                    path="*"
                    element={<Navigate replace relative="path" to=".." />}
                  />
                </Route>
              </Routes>
            </AppContextProvider>
          </EventServiceProvider>
        </QueryClientProvider>
      </FeatureMaintenance>
    </ErrorBoundary>
  );
}

export default App;
